<template>
  <div class="curjus">
      <span>{{getCurrency}}</span>
      <span>{{getValue}}</span>
  </div>
</template>

<script>
export default {
  name: "CurrencyJustified",
  props: {
    currencyValue: String,
    valueNumber: 0,
    deci2: Boolean,
  },
  data(){
    return {
      return_currency: "",
      return_value: 0,
    }
  },

  computed:{
      getCurrency(){
              //let value = this.valueNumber;
              let currency = this.currencyValue;
              if (currency === null || currency === undefined || currency === "" || currency === ''){
                  currency = 'IDR';
              }

              let numb = 0;
              //let spac = "";
              let textVal2 = new Intl.NumberFormat('id-ID', {style: 'currency', currency: currency}).format(numb);
              let diff = textVal2.replace("0,00","").replace("0","");
              //let result = value < 0 ? (spac.concat("(",diff)) : diff;  //tanda kurung minus didepan Rupiah
              let result = diff;                                          //tanpa tanda kurung minus didepan Rupiah
              return this.deci2 ? result : result.replace(",00","")
      },
      getValue(){
              let value = this.valueNumber;
              let currency = this.currencyValue;

              if (currency === null || currency === undefined || currency === "" || currency === ''){
                  currency = 'IDR';
              }

              if (value === null || value===undefined) {
                  value = 0
              }
              
              let numb = 0;
              let textVal1 = new Intl.NumberFormat('id-ID', {style: 'currency', currency: currency}).format(value);
              let textVal2 = new Intl.NumberFormat('id-ID', {style: 'currency', currency: currency}).format(numb);
              let diff = textVal2.replace("0,00","").replace("0","");
              let result = value<0 ? "("+(textVal1.replace("-"+diff,"")+")") : textVal1.replace(diff,"");
              return this.deci2 ? result : result.replace(",00","")
      }
  }

};
</script>

<style lang="less" scoped>
.curjus{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>